<template>
  <el-form :model="queryParams" ref="queryForm" :inline="true">
    <el-row :gutter="20">
      <el-col :span="20" :offset="0">
        <el-form-item label="展会编号" prop="exhibitionCode" style="margin-bottom: 5px;">
          <el-input v-model="queryParams.exhibitionCode" placeholder="请输入展会编号" clearable size="small"
            style="width: 240px" @keyup.enter.native="handleQuery" />
        </el-form-item>
        <el-form-item label="展会名称" prop="exhibitionName" style="margin-bottom: 5px;">
          <el-input v-model="queryParams.exhibitionName" placeholder="请输入展会名称" clearable size="small"
            style="width: 240px" @keyup.enter.native="handleQuery" />
        </el-form-item>
        <!-- 报馆时间 -->
        <el-form-item label="报馆时间" prop="reportTime" style="margin-bottom: 5px;">
          <el-date-picker style="width: 240px;" format="yyyy-MM-dd" value-format="timestamp"
            v-model="applyDateList" type="daterange" range-separator="-" start-placeholder="开始日期"
            end-placeholder="结束日期" @change="handleDateChange">
          </el-date-picker>
        </el-form-item>
      </el-col>
      <el-col :span="4" :offset="0">
        <el-form-item style="margin-bottom: 5px;text-align:right;">
          <el-button type="primary" size="mini" @click="handleQuery">查询</el-button>
          <el-button type="primary" size="mini" plain @click="resetForm">重置</el-button>
        </el-form-item>
      </el-col>
    </el-row>
  </el-form>
</template>

<script>
// import { industryListApi, regionListApi } from '@/api/exhibitionList';
export default {
  name: 'ExchangeExhibitionForm',
  components: {},
  props: {
    queryParams: {
      type: Object,
      default: () => ({})
    },
    handleQuery: {
      type: Function,
      default: () => { }
    },
    resetQuery: {
      type: Function,
      default: () => { }
    },
    applyDateListChange: {
      type: Function,
      default: () => { }
    }
  },
  data() {
    return {
      industryOptions: [],
      regionOptions: [],
      applyDateList: [],
    }
  },
  created() {
    // this.getIndustryOptions();
    // this.getRegionOptions();
  },
  methods: {
    // 表单重置
    resetForm() {
      this.$refs["queryForm"].resetFields();
      this.applyDateList = [];
      this.resetQuery();
    },
    // 日期选择器变化时，通知父组件更新 applyDateList
    handleDateChange(value) {
      console.log('handleDateChange', value);
      this.$nextTick(() => {
        this.applyDateListChange(value||[]);
      });
    },
    // 获取项目行业字典
    // async getIndustryOptions() {
    //   const res = await industryListApi();
    //   this.industryOptions = res;

    // },
    // regionListApi
    // async getRegionOptions() {
    //   const res = await regionListApi();
    //   this.regionOptions = res;
    // },
  },
}
</script>
<style scoped></style>